<template>
  <div>
    <div class="d-flex justify-space-between mb-4">
      <div class="d-flex align-center" style="gap: 10px">
        <v-btn
          icon="mdi-arrow-left"
          @click="
            $store.commit('setPostMode', null);
            media = [];
          "
          variant="text"
          size="small"
        ></v-btn>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" variant="tonal" size="small">
              {{ selectedTemplateTitle }}
            </v-btn>
          </template>
          <v-card width="300">
            <v-list density="compact">
              <v-list-item
                density="compact"
                v-if="category?.template"
                style="font-size: 10pt"
                link
                @click="selectedTemplate = 'category'"
              >
                Category template
              </v-list-item>
              <v-list-item
                density="compact"
                style="font-size: 10pt"
                v-for="template in templates.sort((a, b) =>
                  a.title.localeCompare(b.title),
                )"
                :key="template.value"
                @click="selectedTemplate = template.value"
              >
                <v-icon
                  size="small"
                  class="mr-2"
                  v-if="selectedTemplate === template.value"
                  >mdi-check</v-icon
                >
                {{ template.title }}
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <div v-if="selectedTemplate !== 'category'">
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" variant="tonal" size="small">
                Variant
                {{
                  (selectedTemplateOptions.findIndex(
                    (opt) => opt.value === selectedTemplateOption,
                  ) ?? 0) + 1
                }}
                <v-icon size="small" class="ml-2">mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-list density="compact">
                <v-list-item
                  style="font-size: 10pt"
                  v-for="(option, index) in selectedTemplateOptions"
                  :key="index"
                  @click="selectedTemplateOption = option.value"
                >
                  Variant {{ index + 1 }}
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </div>

      <v-menu :close-on-content-click="false" :model-value="isActive">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="tonal"
            size="small"
            style="margin-top: 6px"
          >
            Edit content
          </v-btn>
        </template>
        <v-card width="400" class="pa-4">
          <template v-if="selectedTemplate === 'category'">
            <h3 class="mb-2">Generate template</h3>
            <p style="font-size: 10pt; font-weight: 400; margin-bottom: 15px">
              Define the elements that need to be replaced in the template. You
              have
              {{ workspace?.counter?.image_tokens || 0 }} image generations
              remaining.
            </p>
            <v-text-field
              v-for="(element, index) in category?.template_elements || []"
              :key="index"
              v-model="templateData[index]"
              :label="element"
              variant="solo"
              flat
              bg-color="smokeDark"
              hide-details=""
              class="mb-2"
            />
            <div
              class="mb-4"
              style="
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;
              "
            >
              <v-btn
                size="small"
                @click="fillFieldsWithAI"
                variant="text"
                :loading="fillingFieldsWithAI"
                flat
                >Fill fields with AI</v-btn
              >
              <v-btn
                size="small"
                :disabled="
                  templateData.length !== category?.template_elements?.length ||
                  workspace?.counter?.image_tokens <= 0 ||
                  fillingFieldsWithAI
                "
                color="primary"
                prepend-icon="mdi-creation"
                @click="generateTemplate"
                :loading="generatingTemplate"
                flat
                >Generate template</v-btn
              >
            </div>
            <div v-if="outputImage">
              <p>Output image:</p>
              <v-img :src="outputImage" cover></v-img>
              <v-btn @click="useGeneratedTemplate" :loading="savingTemplate"
                >Use generated template</v-btn
              >
            </div>
          </template>
          <!-- Quote template fields -->
          <template v-if="selectedTemplate === 'quote'">
            <v-textarea
              v-model="selectedTemplateData.quote"
              label="Quote"
              flat
              variant="solo"
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.author"
              label="Author"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.author_bio"
              label="Author Bio"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
          </template>

          <!-- Stats template fields -->
          <template v-if="selectedTemplate === 'stats'">
            <v-text-field
              v-model="selectedTemplateData.number"
              label="Number"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field v-model="selectedTemplateData.label" label="Label" />
            <v-text-field
              v-model="selectedTemplateData.subtitle"
              label="Subtitle"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
          </template>

          <!-- Tips template fields -->
          <template v-if="selectedTemplate === 'tips'">
            <v-text-field
              v-model="selectedTemplateData.title"
              label="Title"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-for="(item, index) in selectedTemplateData.items"
              :key="index"
              v-model="selectedTemplateData.items[index]"
              :label="`Tip ${index + 1}`"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
          </template>

          <!-- Testimonial template fields -->
          <template v-if="selectedTemplate === 'testimonial'">
            <v-textarea
              v-model="selectedTemplateData.quote"
              label="Quote"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.name"
              label="Name"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.role"
              label="Role"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.company"
              label="Company"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-slider
              v-model="selectedTemplateData.rating"
              :min="1"
              :max="5"
              :step="1"
              label="Rating"
              thumb-label
            />
          </template>

          <!-- Announcement template fields -->
          <template v-if="selectedTemplate === 'announcement'">
            <v-text-field
              v-model="selectedTemplateData.headline"
              label="Headline"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-textarea
              v-model="selectedTemplateData.subheadline"
              label="Subheadline"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field v-model="selectedTemplateData.cta" label="CTA" />
          </template>

          <!-- Before/After template fields -->
          <template v-if="selectedTemplate === 'beforeAfter'">
            <v-text-field
              v-model="selectedTemplateData.context"
              label="Context"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.beforeLabel"
              label="Before Label"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.beforeValue"
              label="Before Value"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.afterLabel"
              label="After Label"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.afterValue"
              label="After Value"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
          </template>

          <!-- Question template fields -->
          <template v-if="selectedTemplate === 'question'">
            <v-textarea
              v-model="selectedTemplateData.question"
              label="Question"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.context"
              label="Context"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
          </template>

          <!-- Checklist template fields -->
          <template v-if="selectedTemplate === 'checklist'">
            <v-text-field
              v-model="selectedTemplateData.title"
              label="Title"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <div
              v-for="(item, index) in selectedTemplateData.items"
              :key="index"
              class="d-flex align-center mb-2"
            >
              <v-checkbox
                v-model="selectedTemplateData.items[index].checked"
                hide-details
                density="compact"
              />
              <v-text-field
                v-model="selectedTemplateData.items[index].text"
                :label="`Item ${index + 1}`"
                hide-details
                density="compact"
              />
            </div>
          </template>

          <!-- Myth vs Fact template fields -->
          <template v-if="selectedTemplate === 'mythVsFact'">
            <v-textarea
              v-model="selectedTemplateData.myth"
              label="Myth"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-textarea
              v-model="selectedTemplateData.fact"
              label="Fact"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
          </template>

          <!-- This or That template fields -->
          <template v-if="selectedTemplate === 'thisOrThat'">
            <v-text-field
              v-model="selectedTemplateData.question"
              label="Question"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.optionA"
              label="Option A"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.optionB"
              label="Option B"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
          </template>

          <!-- Profile template fields -->
          <template v-if="selectedTemplate === 'profile'">
            <v-text-field
              v-model="selectedTemplateData.name"
              label="Name"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-text-field
              v-model="selectedTemplateData.title"
              label="Title"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
            <v-textarea
              v-model="selectedTemplateData.bio"
              label="Bio"
              variant="solo"
              flat
              bg-color="smokeDark"
            />
          </template>

          <v-text-field
            v-if="selectedTemplateData && selectedTemplate !== 'category'"
            v-model="selectedTemplateData.chip"
            label="Chip"
            variant="solo"
            flat
            bg-color="smokeDark"
          />
        </v-card>
      </v-menu>
    </div>

    <!-- <v-btn @click="getHTML"> Get HTML </v-btn> -->

    <div class="image-editor-container" v-if="selectedTemplate !== 'category'">
      <div class="image-editor-wrapper">
        <component
          v-if="currentComponent && selectedTemplate"
          :is="currentComponent"
          ref="currentComponent"
          :data="selectedTemplateData"
          :scale="scale"
        ></component>
      </div>
    </div>
    <div v-else-if="selectedTemplate === 'category'">
      <v-img
        :src="
          allMedia.find((m) => m.uid === category?.template)?.src ||
          allMedia.find((m) => m.uid === category?.template)?.thumbnail
        "
        cover
        max-height="400"
        style="border-radius: 6px"
      ></v-img>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import QuoteOne from "./templates/quotes/quoteOne.vue";
import QuoteTwo from "./templates/quotes/quoteTwo.vue";
import QuoteThree from "./templates/quotes/quoteThree.vue";
import QuoteFour from "./templates/quotes/quoteFour.vue";
import StatsOne from "./templates/stats/statsOne.vue";
import StatsTwo from "./templates/stats/statsTwo.vue";
import StatsThree from "./templates/stats/statsThree.vue";
import StatsFour from "./templates/stats/statsFour.vue";
import TipsOne from "./templates/tips/tipsOne.vue";
import TipsTwo from "./templates/tips/tipsTwo.vue";
import TipsThree from "./templates/tips/tipsThree.vue";
import TipsFour from "./templates/tips/tipsFour.vue";
import TestimonialOne from "./templates/testimonial/testimonialOne.vue";
import TestimonialTwo from "./templates/testimonial/testimonialTwo.vue";
import TestimonialThree from "./templates/testimonial/testimonialThree.vue";
import TestimonialFour from "./templates/testimonial/testimonialFour.vue";
import AnnouncementOne from "./templates/announcement/announcementOne.vue";
import AnnouncementTwo from "./templates/announcement/announcementTwo.vue";
import AnnouncementThree from "./templates/announcement/announcementThree.vue";
import AnnouncementFour from "./templates/announcement/announcementFour.vue";
import BeforeAfterOne from "./templates/beforeAfter/beforeAfterOne.vue";
import BeforeAfterTwo from "./templates/beforeAfter/beforeAfterTwo.vue";
import BeforeAfterThree from "./templates/beforeAfter/beforeAfterThree.vue";
import BeforeAfterFour from "./templates/beforeAfter/beforeAfterFour.vue";
import QuestionOne from "./templates/question/questionOne.vue";
import QuestionTwo from "./templates/question/questionTwo.vue";
import QuestionThree from "./templates/question/questionThree.vue";
import QuestionFour from "./templates/question/questionFour.vue";
import ChecklistOne from "./templates/checklist/checklistOne.vue";
import ChecklistTwo from "./templates/checklist/checklistTwo.vue";
import ChecklistThree from "./templates/checklist/checklistThree.vue";
import ChecklistFour from "./templates/checklist/checklistFour.vue";
import MythVsFactOne from "./templates/mythVsFact/mythVsFactOne.vue";
import MythVsFactTwo from "./templates/mythVsFact/mythVsFactTwo.vue";
import MythVsFactThree from "./templates/mythVsFact/mythVsFactThree.vue";
import MythVsFactFour from "./templates/mythVsFact/mythVsFactFour.vue";
import ThisOrThatOne from "./templates/thisOrThat/thisOrThatOne.vue";
import ThisOrThatTwo from "./templates/thisOrThat/thisOrThatTwo.vue";
import ThisOrThatThree from "./templates/thisOrThat/thisOrThatThree.vue";
import ThisOrThatFour from "./templates/thisOrThat/thisOrThatFour.vue";
import ProfileOne from "./templates/profile/profileOne.vue";
import ProfileTwo from "./templates/profile/profileTwo.vue";
import ProfileThree from "./templates/profile/profileThree.vue";
import ProfileFour from "./templates/profile/profileFour.vue";

export default {
  name: "ImageBuilder",
  components: {
    QuoteOne,
    QuoteTwo,
    QuoteThree,
    QuoteFour,
    StatsOne,
    StatsTwo,
    StatsThree,
    StatsFour,
    TipsOne,
    TipsTwo,
    TipsThree,
    TipsFour,
    TestimonialOne,
    TestimonialTwo,
    TestimonialThree,
    TestimonialFour,
    AnnouncementOne,
    AnnouncementTwo,
    AnnouncementThree,
    AnnouncementFour,
    BeforeAfterOne,
    BeforeAfterTwo,
    BeforeAfterThree,
    BeforeAfterFour,
    QuestionOne,
    QuestionTwo,
    QuestionThree,
    QuestionFour,
    ChecklistOne,
    ChecklistTwo,
    ChecklistThree,
    ChecklistFour,
    MythVsFactOne,
    MythVsFactTwo,
    MythVsFactThree,
    MythVsFactFour,
    ThisOrThatOne,
    ThisOrThatTwo,
    ThisOrThatThree,
    ThisOrThatFour,
    ProfileOne,
    ProfileTwo,
    ProfileThree,
    ProfileFour,
  },
  data() {
    return {
      isActive: false,
      scale: 0.8,
      templateData: [],
      outputImage: null,
      generatingTemplate: false,
      fillingFieldsWithAI: false,
      savingTemplate: false,
      templates: [
        {
          title: "Quote",
          value: "quote",
          data: {
            quote:
              "Using LinkedIn without consistency is like *a ship without a compass*.",
            author: "John Doe",
            author_bio: "Author is a software engineer at Google",
            chip: "Founders quotes",
          },
          options: [
            { value: "quoteOne" },
            { value: "quoteTwo" },
            { value: "quoteThree" },
            { value: "quoteFour" },
          ],
        },
        {
          title: "Stats",
          value: "stats",
          data: {
            number: "147%",
            label: "Revenue Growth",
            subtitle: "Q4 2025 vs Q4 2024",
            chip: "Company Update",
          },
          options: [
            { value: "statsOne" },
            { value: "statsTwo" },
            { value: "statsThree" },
            { value: "statsFour" },
          ],
        },
        {
          title: "Tips",
          value: "tips",
          data: {
            title: "3 LinkedIn Growth Tips",
            items: [
              "Post consistently at peak hours",
              "Use carousels for higher reach",
              "Reply to every comment",
            ],
            chip: "LinkedIn Tips",
          },
          options: [
            { value: "tipsOne" },
            { value: "tipsTwo" },
            { value: "tipsThree" },
            { value: "tipsFour" },
          ],
        },
        {
          title: "Testimonial",
          value: "testimonial",
          data: {
            quote:
              "This product completely transformed how we work. The results speak for themselves.",
            name: "Sarah Johnson",
            role: "Head of Marketing",
            company: "TechCorp Inc.",
            rating: 5,
            chip: "Customer Story",
          },
          options: [
            { value: "testimonialOne" },
            { value: "testimonialTwo" },
            { value: "testimonialThree" },
            { value: "testimonialFour" },
          ],
        },
        {
          title: "Announcement",
          value: "announcement",
          data: {
            headline: "We just launched something big",
            subheadline:
              "Introducing our new AI-powered feature that will change how you work",
            cta: "Learn More →",
            chip: "Product Update",
          },
          options: [
            { value: "announcementOne" },
            { value: "announcementTwo" },
            { value: "announcementThree" },
            { value: "announcementFour" },
          ],
        },
        {
          title: "Before/After",
          value: "beforeAfter",
          data: {
            beforeLabel: "Before",
            beforeValue: "12 hours",
            afterLabel: "After",
            afterValue: "30 minutes",
            context: "Time to complete monthly reports",
            chip: "Results",
          },
          options: [
            { value: "beforeAfterOne" },
            { value: "beforeAfterTwo" },
            { value: "beforeAfterThree" },
            { value: "beforeAfterFour" },
          ],
        },
        {
          title: "Question",
          value: "question",
          data: {
            question:
              "What's the biggest challenge you face when creating content?",
            context: "Drop your answer in the comments 👇",
            chip: "Let's Discuss",
          },
          options: [
            { value: "questionOne" },
            { value: "questionTwo" },
            { value: "questionThree" },
            { value: "questionFour" },
          ],
        },
        {
          title: "Checklist",
          value: "checklist",
          data: {
            title: "Content Launch Checklist",
            items: [
              { text: "Write compelling headline", checked: true },
              { text: "Add visuals and graphics", checked: true },
              { text: "Proofread for errors", checked: false },
              { text: "Schedule for optimal time", checked: false },
            ],
            chip: "Checklist",
          },
          options: [
            { value: "checklistOne" },
            { value: "checklistTwo" },
            { value: "checklistThree" },
            { value: "checklistFour" },
          ],
        },
        {
          title: "Myth vs Fact",
          value: "mythVsFact",
          data: {
            myth: "You need to post every day to grow on LinkedIn",
            fact: "Consistency matters more than frequency. 3 quality posts per week beats 7 rushed ones.",
            chip: "Myth Busted",
          },
          options: [
            { value: "mythVsFactOne" },
            { value: "mythVsFactTwo" },
            { value: "mythVsFactThree" },
            { value: "mythVsFactFour" },
          ],
        },
        {
          title: "This or That",
          value: "thisOrThat",
          data: {
            question: "Which do you prefer?",
            optionA: "Remote Work",
            optionB: "Office Work",
            chip: "This or That",
          },
          options: [
            { value: "thisOrThatOne" },
            { value: "thisOrThatTwo" },
            { value: "thisOrThatThree" },
            { value: "thisOrThatFour" },
          ],
        },
        {
          title: "Profile",
          value: "profile",
          data: {
            name: "Jane Smith",
            title: "Product Designer",
            bio: "Passionate about creating intuitive user experiences that drive business growth.",
            chip: "Meet the Team",
          },
          options: [
            { value: "profileOne" },
            { value: "profileTwo" },
            { value: "profileThree" },
            { value: "profileFour" },
          ],
        },
      ],
      // Map template option values to their component names
      componentMap: {
        quoteOne: "QuoteOne",
        quoteTwo: "QuoteTwo",
        quoteThree: "QuoteThree",
        quoteFour: "QuoteFour",
        statsOne: "StatsOne",
        statsTwo: "StatsTwo",
        statsThree: "StatsThree",
        statsFour: "StatsFour",
        tipsOne: "TipsOne",
        tipsTwo: "TipsTwo",
        tipsThree: "TipsThree",
        tipsFour: "TipsFour",
        testimonialOne: "TestimonialOne",
        testimonialTwo: "TestimonialTwo",
        testimonialThree: "TestimonialThree",
        testimonialFour: "TestimonialFour",
        announcementOne: "AnnouncementOne",
        announcementTwo: "AnnouncementTwo",
        announcementThree: "AnnouncementThree",
        announcementFour: "AnnouncementFour",
        beforeAfterOne: "BeforeAfterOne",
        beforeAfterTwo: "BeforeAfterTwo",
        beforeAfterThree: "BeforeAfterThree",
        beforeAfterFour: "BeforeAfterFour",
        questionOne: "QuestionOne",
        questionTwo: "QuestionTwo",
        questionThree: "QuestionThree",
        questionFour: "QuestionFour",
        checklistOne: "ChecklistOne",
        checklistTwo: "ChecklistTwo",
        checklistThree: "ChecklistThree",
        checklistFour: "ChecklistFour",
        mythVsFactOne: "MythVsFactOne",
        mythVsFactTwo: "MythVsFactTwo",
        mythVsFactThree: "MythVsFactThree",
        mythVsFactFour: "MythVsFactFour",
        thisOrThatOne: "ThisOrThatOne",
        thisOrThatTwo: "ThisOrThatTwo",
        thisOrThatThree: "ThisOrThatThree",
        thisOrThatFour: "ThisOrThatFour",
        profileOne: "ProfileOne",
        profileTwo: "ProfileTwo",
        profileThree: "ProfileThree",
        profileFour: "ProfileFour",
      },
    };
  },
  mounted() {
    // Initialize selectedTemplate to first template
    if (!this.selectedTemplate) {
      this.selectedTemplate = this.templates[0].value;
      this.selectedTemplateOption = this.templates[0].options[0].value;
      this.selectedTemplateData = this.templates[0].data;
    }

    this.updateEditorScale();
    window.addEventListener("resize", this.updateEditorScale);
    this.updateMedia();
    // Register getHTML function in store so other components can call it
    this.$store.commit("setPostGetHTMLFn", this.getHTML);
  },
  unmounted() {
    window.removeEventListener("resize", this.updateEditorScale);
    // Unregister when component is destroyed
    this.$store.commit("setPostGetHTMLFn", null);
  },
  computed: {
    ...mapState({
      category: (state) =>
        state.posts.categories.find((c) => c.uid === state.post.category.uid),
      allMedia: (state) => state.media.media,
      userProfile: (state) => state.users.userProfile,
      workspace: (state) => state.workspace.workspace,
    }),
    selectedTemplateTitle() {
      return (
        this.templates.find((t) => t.value === this.selectedTemplate)?.title ||
        "Pick template"
      );
    },
    selectedTemplateOptions() {
      return (
        this.templates.find(
          (template) => template.value === this.selectedTemplate,
        )?.options || []
      );
    },
    selectedTemplate: {
      get() {
        return this.$store.state.post.selectedTemplate;
      },
      set(value) {
        this.$store.commit("setPostSelectedTemplate", value);
      },
    },
    selectedTemplateOption: {
      get() {
        return this.$store.state.post.selectedTemplateOption;
      },
      set(value) {
        this.$store.commit("setPostSelectedTemplateOption", value);
      },
    },
    selectedTemplateData: {
      get() {
        return this.$store.state.post.selectedTemplateData;
      },
      set(value) {
        this.$store.commit("setPostSelectedTemplateData", value);
      },
    },
    media: {
      get() {
        return this.$store.state.post.media;
      },
      set(value) {
        this.$store.commit("setPostMedia", value);
      },
    },
    html: {
      get() {
        return this.$store.state.post.html;
      },
      set(value) {
        this.$store.commit("setPostHTML", value);
      },
    },
    currentComponent() {
      if (!this.selectedTemplateOption) {
        return null;
      }
      return this.componentMap[this.selectedTemplateOption] || null;
    },
    currentVariationText() {
      return this.$store.state.post.variations[this.$store.state.post.tab].text;
    },
  },
  watch: {
    selectedTemplateData: {
      handler() {
        this.updateMedia();
      },
      deep: true,
    },
    selectedTemplateOption() {
      this.updateMedia();
    },
    selectedTemplate(newTemplateValue) {
      // Reset to first variant when template changes
      const templateDef = this.templates.find(
        (t) => t.value === newTemplateValue,
      );
      if (templateDef) {
        this.selectedTemplateOption = templateDef.options[0].value;
        this.selectedTemplateData = { ...templateDef.data };
      }
    },
  },
  methods: {
    updateMedia() {
      if (!this.selectedTemplate) return;
      this.media = [
        {
          type: "template",
          template: this.selectedTemplate,
          option: this.selectedTemplateOption,
          data: this.selectedTemplateData,
        },
      ];
    },
    updateEditorScale() {
      const wrapper = document.querySelector(".image-editor-wrapper");
      if (!wrapper) return;

      const container = document.querySelector(".image-editor-container");
      const containerWidth = container.offsetWidth;

      // Calculate scale to fit 1080px editor in available space with padding
      const availableWidth = containerWidth; // Account for padding
      console.log("availableWidth", availableWidth);
      const scale = Math.min(availableWidth / 1200); // Max scale of 0.8

      this.scale = scale;
    },
    nextOption() {
      if (!this.selectedTemplateOptions) return;
      let index =
        this.selectedTemplateOptions.findIndex(
          (opt) => opt.value === this.selectedTemplateOption,
        ) + 1;
      if (index >= this.selectedTemplateOptions.length) {
        index = 0;
      }
      this.selectedTemplateOption = this.selectedTemplateOptions[index].value;
    },
    getHTML() {
      const styleSheets = document.styleSheets;
      let templateCSS = "";

      // Extract template-related CSS
      for (let sheet of styleSheets) {
        try {
          const rules = sheet.cssRules || sheet.rules;
          for (let rule of rules) {
            const cssText = rule.cssText;
            // Include template-specific CSS and base resets
            if (
              cssText.includes(".template-") ||
              cssText.includes("body") ||
              cssText.includes("*")
            ) {
              templateCSS += cssText + "\n";
            }
          }
        } catch (e) {
          // Skip cross-origin stylesheets
        }
      }

      let slideContent = this.$refs.currentComponent.exportHTML(true);
      console.log("slideContent", slideContent);
      let html = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Quote</title>
    <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Libre+Baskerville:ital,wght@1,500&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        body {
            width: 1200px;
            height: 1200px;
            overflow: hidden;
            font-family: "Inter", sans-serif;
            letter-spacing: 0.1pt;
            line-height: 1.5;
        }
        .template-libre {
            font-family: "Libre Baskerville", serif;
            font-weight: 500;
            font-style: italic;
        }
        ${templateCSS}
    </style>
</head>
<body>
    ${slideContent}
</body>
</html>`;
      console.log("html", html);
      return html;
    },
    async generateTemplate() {
      this.generatingTemplate = true;
      try {
        const generateTemplate = httpsCallable(
          functions,
          "geminiGenerateImage",
        );
        const res = await generateTemplate({
          prompt: `Generate an image based on the attached template. Keep font, styling, brand colors, and layout intact. Replace the following placeholders with the actual content: ${this.category?.template_elements?.map((e, index) => `{{${e}}}: ${this.templateData[index]}`).join(", ")}`,
          imageUrl: this.allMedia.find((m) => m.uid === this.category?.template)
            ?.src,
          workspace: this.userProfile.workspace,
        });
        console.log(res.data);
        if (res.data.success) {
          this.outputImage = res.data.image.dataUrl;
        } else {
          this.$store.commit("setNotification", {
            show: true,
            text: res.data.error,
            type: "error",
            icon: "mdi-alert",
          });
        }
      } catch (error) {
        console.error(error);
        this.$store.commit("setNotification", {
          show: true,
          text: error.message,
          type: "error",
          icon: "mdi-alert",
        });
      } finally {
        this.generatingTemplate = false;
      }
    },
    async useGeneratedTemplate() {
      this.savingTemplate = true;
      const useGeneratedImage = httpsCallable(functions, "useGeneratedImage");
      const res = await useGeneratedImage(this.outputImage);
      console.log(res.data);
      await this.$store.dispatch("fetchMedia");
      console.log(this.allMedia);
      this.media = [];
      this.media.push(this.allMedia.find((m) => m.uid === res.data));
      console.log(this.media);
      this.$store.commit("setPostMode", null);
      this.isActive = false;
      this.savingTemplate = false;
    },
    async fillFieldsWithAI() {
      console.log("fillFieldsWithAI");
      this.fillingFieldsWithAI = true;

      try {
        const fillFieldsWithAI = httpsCallable(functions, "fillFieldsWithAI");

        const res = await fillFieldsWithAI({
          post: this.currentVariationText,
          image: this.allMedia.find((m) => m.uid === this.category?.template)
            ?.src,
          variables: this.category?.template_elements,
        });
        console.log(res.data);
        this.templateData = res.data;
      } catch (error) {
        console.error(error);
        this.$store.commit("setNotification", {
          show: true,
          text: error.message,
          type: "error",
          icon: "mdi-alert",
        });
      } finally {
        this.fillingFieldsWithAI = false;
      }
    },
  },
};
</script>
